<template>
  <div>
    <navBar></navBar>
    <div class="content-bg">
      {{ activeinfo?.title }}
    </div>
    <div class="content-form">
      <p class="title">填写信息</p>
      <van-field v-model="phoneNumber" name="用户名" label="" placeholder="手机号" />
    </div>
    <div class="btn">
      <van-button type="info" @click="savesign" round>立即签到</van-button>
    </div>
  </div>
</template>
<script>
import navBar from "@/components/navBar.vue";
import { gosign } from "@/api/home";
import { Toast } from "vant";
import { eventInfoDetail } from "@/api/home/index";
export default {
  components: {
    navBar,
  },
  data() {
    return {
      phoneNumber: "",
      eventId: null,
      id: null,
      activeinfo: null,
    };
  },
  methods: {
    onSubmit(values) {
      console.log("submit", values);
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    savesign() {
      gosign({ eventId: this.eventId, phoneNumber: this.phoneNumber }).then(
        (res) => {
          Toast.success(res.message);
          console.log(res);
        }
      ).catch((e) => {
        Toast.fail(e.message);
      });
    },
    getavtive() {
      const route = this.$route;
      eventInfoDetail(this.eventId, route).then((res) => {
        // console.log(res);
        this.activeinfo = res;
      });
    },
  },
  created() {
    this.eventId = this.$route.query.id;
    this.getavtive();
  },
};
</script>
<style lang="scss" scoped>
.content-bg {
  margin-top: 46px;
  width: 100%;
  height: 195px;
  background: url(../../assets/images/regist-bg.png) no-repeat;
  background-size: cover;
  color: #fff;
  padding: 32px 40px 0;
  font-size: 18px;
  line-height: 32px;
  box-sizing: border-box;
}

.content-form {
  margin: 0 18px;
  margin-top: -80px;
  background: #fff;
  border-radius: 20px;
  padding: 15px 22px 22px;

  .title {
    font-size: 20px;
    line-height: 28px;
  }

  .van-cell {
    overflow: visible;

    :deep .van-field__value {
      background-color: #f6f6f6;
      border-radius: 20px;
      padding: 10px 20px;
      margin: 20px -20px 0;
    }
  }
}

.btn {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  width: 88vw;
  text-align: left;

  .van-button {
    // width: calc(100% - 36px);
    width: 100%;
    background: #2553e2;
  }
}
</style>